import React from 'react';
import Tag from '$app/apps/bookings/components/Tag';

const PaymentMethodTag = ({ children }) => {
  let color = '#DCDCDC';
  let content = 'Card';
  let fontColor = '#000';
  switch (children) {
    case 'klarna':
      color = '#FFC1CB';
      content = 'Klarna';
      break;
    case 'paypal':
      color = '#0070BA';
      content = 'PayPal';
      fontColor = '#fff';
      break;
    default:
      break;
  }
  return (
    <Tag color={color} style={{ color: { fontColor }, fontSize: '12px' }}>
      {content}
    </Tag>
  );
};

export default PaymentMethodTag;
